<app-common-page-breadcrumbs [navigationData]="navigationData" [pageTitle]="title">
</app-common-page-breadcrumbs>

<div *ngIf="contactdetails == 'false'">
  <div *ngIf="!enableLoader">
  </div>
  <div *ngIf="enableLoader" class="align-items-center" id="loader"></div>
  <div class="container text-center strong  text-secondary py-4" *ngIf="noData">{{'home.contracts.Noresults' | cxTranslate }}</div>
  <!-- <div class="h-10 visible-xs" *ngIf="enableLoader">

  </div> -->

  <div class="container d-flex justify-content-center flex-column py-4">
    <div class="desktop d-flex flex-row-reverse  visible-xs"  *ngIf="admin && !enableLoader">
      <!-- <button disabled (click)="openaddcontact()" type="button" class="btn btn-primary mb-4 ">{{'heading.AddNewContact' |
        cxTranslate}}</button> -->
    </div>
    <table  *ngIf="!enableLoader" class="d-none d-lg-block" >
      <thead role="rowgroup" *ngIf="!noData">
        <tr role="row" class="bg-table-header border-bottom " *ngIf="!noData">
          <th class=' p-7'>{{'heading.Name' | cxTranslate}} </th>
          <th class=' p-7'>{{'heading.Email' | cxTranslate}}</th>
          <th class=' p-7'>{{'heading.Mobile' | cxTranslate}}</th>
          <th class=' p-7'>{{'heading.CompanyName' | cxTranslate}}</th>
          <th class=' p-7'>{{'heading.BhpConnect' | cxTranslate}}</th>
          <th class=' p-7'>{{'heading.userRole' | cxTranslate}}</th>
          <th class=' p-7'>{{'heading.commodityType' | cxTranslate}}</th>
        </tr>
      </thead>

      <tbody role="rowgroup">
        <tr role="row" (click)="openDetailscontact(user)" *ngFor="let user of contacts;let i=index " class="bg-white border-bottom pe-auto">
          <td class=' p-7' [attr.data-label]="'heading.Name' | cxTranslate" role="cell">{{user.name | titlecase}}<img src="/images/contactOrange.svg" alt="Phone"
            class="ml-2 mobile-icon"></td>
          <td class=' p-7' [attr.data-label]="'heading.Email' | cxTranslate" role="cell"><a>{{user.uid}}</a></td>
          <td class=' p-7' [attr.data-label]="'heading.Mobile' | cxTranslate" role="cell">{{user.mobileNumber?user.mobileNumber:'Not Available'}}<img src="/images/revertedphoneOrange.svg" alt="Phone"
            class="ml-2 mobile-icon"></td>
          <td class=' p-7' [attr.data-label]="'heading.CompanyName' | cxTranslate" role="cell">
            {{user.orgUnit.name?user.orgUnit.name:"Not available"}}</td>
            <td class=' p-7' [attr.data-label]="'heading.BhpConnect' | cxTranslate" role="cell">
              {{user.accessIndicator?"Yes":"No"}}</td>
              <td class=' p-7' [attr.data-label]="'heading.userRole' | cxTranslate" role="cell"><span *ngFor="let ur of user.userRole; let j = index">{{ur.description?ur.description:"Not available"}} {{j === user?.userRole.length-1 ? '': ',&nbsp;'}}</span></td>
                <td class=' p-7' [attr.data-label]="'heading.commodityType' | cxTranslate" role="cell"><span *ngFor="let ct of user.commodityType;let l = index">{{ct.description}}{{l === user?.commodityType.length -1 ? '' : ',&nbsp;' }}</span></td>
        </tr>
      </tbody>
    </table>
    <table  *ngIf="!enableLoader" class="d-lg-none table-responsive" >
      <thead role="rowgroup" *ngIf="!noData">
        <tr role="row" class="bg-white border-bottom " *ngIf="!noData">
          <th class=' p-2'>{{'heading.Name' | cxTranslate}} </th>
          <th class=' p-2'>{{'heading.Email' | cxTranslate}}</th>
          <th class=' p-2'>{{'heading.Mobile' | cxTranslate}}</th>
          <th class=' p-2'>{{'heading.CompanyName' | cxTranslate}}</th>
          <th class=' p-2'>{{'heading.BhpConnect' | cxTranslate}}</th>
          <th class=' p-2'>{{'heading.userRole' | cxTranslate}}</th>
          <th class=' p-2'>{{'heading.commodityType' | cxTranslate}}</th>
        </tr>
      </thead>
      <tbody>
        <tr role="row" (click)="openDetailscontact(user)" *ngFor="let user of contacts;let i=index " class="bg-white border-bottom pe-auto">
          <td class='p-2' [attr.data-label]="'heading.Name' | cxTranslate" role="">{{user.name | titlecase}}
            <!-- <img src="/images/contactOrange.svg" alt="Phone"
            class="ml-2 mobile-icon"> -->
          </td>
          <td class=' p-2' [attr.data-label]="'heading.Email' | cxTranslate" role=""><a>{{user.uid}}</a></td>
          <td class=' p-2' [attr.data-label]="'heading.Mobile' | cxTranslate" role="">{{user.mobileNumber?user.mobileNumber:'Not Available'}}
            <!-- <img src="/images/revertedphoneOrange.svg" alt="Phone"
            class="ml-2 mobile-icon"> -->
          </td>
          <td class=' p-2' [attr.data-label]="'heading.CompanyName' | cxTranslate" role="">
            {{user.orgUnit.name?user.orgUnit.name:"Not available"}}</td>
            <td class=' p-2' [attr.data-label]="'heading.BhpConnect' | cxTranslate" role="">
              {{user.accessIndicator?"Yes":"No"}}</td>
            <td class=' p-2' [attr.data-label]="'heading.userRole' | cxTranslate" role=""><span *ngFor="let ur of user.userRole; let j = index">{{ur.description?ur.description:"Not available"}} {{j === user?.userRole.length-1 ? '': ',&nbsp;'}}</span></td>
            <td class=' p-2' [attr.data-label]="'heading.commodityType' | cxTranslate" role=""><span *ngFor="let ct of user.commodityType;let l = index">{{ct.description}}{{l === user?.commodityType.length -1 ? '' : ',&nbsp;' }}</span></td>
        </tr>
      </tbody>
      </table>
  </div>
</div>
<app-custom-add-edit-contact *ngIf="contactdetails == true" [addupdate]="addupdate" [updatecontact]="updatecontact"
  (messageEvent)="receiveMessage($event)" [admin]="admin"></app-custom-add-edit-contact>
